/* unplugin-vue-components disabled */import { render } from "./gradient-text.vue?vue&type=template&id=359f84aa&scoped=true"
import script from "./gradient-text.vue?vue&type=script&lang=js"
export * from "./gradient-text.vue?vue&type=script&lang=js"

import "./gradient-text.vue?vue&type=style&index=0&id=359f84aa&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359f84aa"],['__file',"src/controls/gradient-text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "359f84aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('359f84aa', __exports__)) {
    api.reload('359f84aa', __exports__)
  }
  
  module.hot.accept("./gradient-text.vue?vue&type=template&id=359f84aa&scoped=true", () => {
    api.rerender('359f84aa', render)
  })

}


export default __exports__